import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Typography, useTheme, Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CachedIcon from "@mui/icons-material/Cached";
/**
 * Loading spinner with different status options.
 * @param text - Text to display below the spinner
 * @param success - If true will display an icon with message
 * @param error - If true will display an icon with message
 * @param processing - If true will display an icon with message
 * @param height - Viewport height. Defaults to auto.
 * @returns
 */
const Loading = (props) => {
    const theme = useTheme();
    return (_jsxs(Stack, Object.assign({ justifyContent: "center", alignItems: "center", height: props.viewportHeight ? props.viewportHeight : "100%", minHeight: "100%" }, { children: [!props.success && !props.error && !props.processing && _jsx(CircularProgress, { color: "primary" }), props.success && (_jsx(CheckCircleIcon, { fontSize: "large", style: { color: theme.palette.success.main, fontSize: 40, marginBottom: theme.spacing(2) } })), props.error && (_jsx(ErrorIcon, { fontSize: "large", style: { color: theme.palette.error.main, fontSize: 40, marginBottom: theme.spacing(2) } })), props.processing && (_jsx(CachedIcon, { fontSize: "large", color: "primary", style: { fontSize: 40, marginBottom: theme.spacing(2) } })), _jsx(Typography, { children: props.text })] })));
};
export default Loading;
